export type PopoverTriggerType = 'click' | 'hover' | 'manual';
